import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import { FaAndroid, FaApple, FaBell, FaTrash, FaCheckSquare } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import player_services from "../../../services/player_services"

class AdminSubscribers extends Component {
    constructor(props) {
        super(props)
        this.state = {
            subscribers: [],
            deactivated: false,
            selectKey: null,
            order: 'asc',
            selected: [],
            processing: false,
        }
    }

    componentDidMount = async () => {
        await this.loadSubscribers()
    }

    loadSubscribers = async () => {
        const subscribers = await player_services.getSubscribers()
        this.setState({ subscribers })
    }

    reorder = async (key) => {
        let order = 'asc'
        if (this.state.selectKey === key && this.state.order === 'asc')
            order = 'desc'
        this.setState({ selectKey: key, order })
        let subscribers = this.state.subscribers
        
        // Check if sorting by date field
        const dateFields = ['created_date', 'updated_date']
        if (dateFields.includes(key)) {
            if (order === 'asc')
                subscribers.sort((a, b) => new Date(a[key] || 0) - new Date(b[key] || 0))
            else
                subscribers.sort((a, b) => new Date(b[key] || 0) - new Date(a[key] || 0))
        } else {
            if (order === 'asc')
                subscribers.sort((a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0))
            else
                subscribers.sort((a, b) => (a[key] < b[key]) ? 1 : ((b[key] < a[key]) ? -1 : 0))
        }
        this.setState({ subscribers })
    }

    selectAll = () => {
        if (this.state.selected.length === this.state.subscribers.length) {
            this.setState({ selected: [] })
        } else {
            let selected = []
            for (let sub of this.state.subscribers) {
                selected.push(sub.subscriber_uuid)
            }
            this.setState({ selected })
        }
    }

    selectSub = (sub) => {
        if (this.state.selected.includes(sub)) {
            let selected = this.state.selected
            const index = selected.indexOf(sub);
            selected.splice(index, 1);
            this.setState({ selected })
        } else
            this.setState({
                selected: [...this.state.selected, sub]
            })
    }

    notifySubs = async () => {
        if (this.state.selected.length === 0)
            NotificationManager.error('Select at least one subscriber')
        else {
            try {
                this.setState({ processing: true })
                const data = await player_services.notifySubscribers(this.state.selected)
                NotificationManager.success(data.message)
                this.loadSubscribers()
                this.setState({ processing: false })
            } catch (e) {
                this.setState({ processing: false })
                NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
            }
        }
    }

    unsub = async () => {
        if (this.state.selected.length === 0)
            NotificationManager.error('Select at least one subscriber')
        else {
            try {
                this.setState({ processing: true })
                const data = await player_services.unsubUser(this.state.selected)
                NotificationManager.success(data.message)
                this.loadSubscribers()
                this.reorder(this.state.selectKey)
                this.setState({ processing: false })
            } catch (e) {
                this.setState({ processing: false })
                NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
            }
        }
    }

    render() {
        return (
            <>
                <AdminLayout 
                    title="Subscribers Management"
                    breadcrumbs={[{ label: 'Subscribers' }]}
                >
                    <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                        {/* Header */}
                        <div className="bg-gradient-to-r from-purple-50 to-pink-50 px-6 py-4 border-b border-gray-200">
                            <div className="flex items-center justify-between flex-wrap gap-3">
                                <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                                    <FaBell className="text-purple-600" />
                                    Registered Subscribers
                                    <span className="ml-2 px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-sm font-semibold">
                                        {this.state.subscribers.length}
                                    </span>
                                </h3>

                                {!this.state.processing && (
                                    <div className="flex gap-3">
                                        <button 
                                            onClick={this.notifySubs}
                                            className="px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-600 text-white rounded-lg hover:from-purple-600 hover:to-pink-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                            disabled={this.state.selected.length === 0}
                                        >
                                            <FaBell />
                                            Notify Subscribers
                                        </button>
                                        <button 
                                            onClick={this.unsub}
                                            className="px-4 py-2 bg-gradient-to-r from-red-500 to-rose-600 text-white rounded-lg hover:from-red-600 hover:to-rose-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                            disabled={this.state.selected.length === 0}
                                        >
                                            <FaTrash />
                                            Confirm Unsubscriptions
                                        </button>
                                    </div>
                                )}
                            </div>

                            {this.state.processing && (
                                <div className="mt-4 px-4 py-3 bg-purple-100 text-purple-700 rounded-lg text-center font-medium">
                                    Processing... please wait
                                </div>
                            )}
                        </div>

                        {/* Table */}
                        {!this.state.processing && (
                            <div className="overflow-x-auto">
                                <table className="w-full">
                                    <thead className="bg-gray-50 border-b border-gray-200">
                                        <tr>
                                            <th className="px-4 py-3 text-center w-12">
                                                <input 
                                                    type="checkbox" 
                                                    onClick={this.selectAll} 
                                                    checked={this.state.selected.length === this.state.subscribers.length && this.state.subscribers.length > 0}
                                                    className="w-4 h-4 text-purple-600 border-gray-300 rounded focus:ring-purple-500 cursor-pointer"
                                                />
                                            </th>
                                            <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase w-12">#</th>
                                            <th 
                                                className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100 transition-colors"
                                                onClick={() => this.reorder("email")}
                                            >
                                                <div className="flex items-center gap-1">
                                                    Email
                                                    {this.state.selectKey === "email" && (
                                                        <span className="text-purple-600">{this.state.order === 'asc' ? '↑' : '↓'}</span>
                                                    )}
                                                </div>
                                            </th>
                                            <th 
                                                className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100 transition-colors"
                                                onClick={() => this.reorder("created_date")}
                                            >
                                                <div className="flex items-center gap-1">
                                                    Registration Date
                                                    {this.state.selectKey === "created_date" && (
                                                        <span className="text-purple-600">{this.state.order === 'asc' ? '↑' : '↓'}</span>
                                                    )}
                                                </div>
                                            </th>
                                            <th 
                                                className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100 transition-colors"
                                                onClick={() => this.reorder("granted")}
                                            >
                                                <div className="flex items-center gap-1">
                                                    Access Grant
                                                    {this.state.selectKey === "granted" && (
                                                        <span className="text-purple-600">{this.state.order === 'asc' ? '↑' : '↓'}</span>
                                                    )}
                                                </div>
                                            </th>
                                            <th 
                                                className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100 transition-colors"
                                                onClick={() => this.reorder("mobile_os")}
                                            >
                                                <div className="flex items-center justify-center gap-1">
                                                    Mobile OS
                                                    {this.state.selectKey === "mobile_os" && (
                                                        <span className="text-purple-600">{this.state.order === 'asc' ? '↑' : '↓'}</span>
                                                    )}
                                                </div>
                                            </th>
                                            <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">
                                                Unsubscribe Status
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200">
                                        {this.state.subscribers.map((subscriber, index) => (
                                            <tr key={`subscriber_${subscriber.subscriber_uuid}`} className="hover:bg-purple-50 transition-colors">
                                                <td className="px-4 py-4 text-center">
                                                    <input 
                                                        type="checkbox" 
                                                        onClick={() => this.selectSub(subscriber.subscriber_uuid)} 
                                                        checked={this.state.selected.includes(subscriber.subscriber_uuid)}
                                                        className="w-4 h-4 text-purple-600 border-gray-300 rounded focus:ring-purple-500 cursor-pointer"
                                                    />
                                                </td>
                                                <td className="px-4 py-4">
                                                    <span className="font-semibold text-gray-700">{index + 1}</span>
                                                </td>
                                                <td className="px-4 py-4">
                                                    <span className="font-semibold text-gray-900">{subscriber.email}</span>
                                                </td>
                                                <td className="px-4 py-4">
                                                    <span className="text-sm text-gray-600">
                                                        {subscriber.created_date.substring(0, 19).replace("T", " ")}
                                                    </span>
                                                </td>
                                                <td className="px-4 py-4">
                                                    {subscriber.granted ? (
                                                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 gap-1">
                                                            <FaCheckSquare />
                                                            GRANTED
                                                        </span>
                                                    ) : (
                                                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                                                            AWAITING
                                                        </span>
                                                    )}
                                                </td>
                                                <td className="px-4 py-4 text-center">
                                                    {subscriber.mobile_os === "ios" && (
                                                        <span className="inline-flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full">
                                                            <FaApple className="text-gray-700 text-lg" />
                                                        </span>
                                                    )}
                                                    {subscriber.mobile_os === "android" && (
                                                        <span className="inline-flex items-center justify-center w-8 h-8 bg-green-100 rounded-full">
                                                            <FaAndroid className="text-green-600 text-lg" />
                                                        </span>
                                                    )}
                                                </td>
                                                <td className="px-4 py-4">
                                                    {subscriber.unsubscribed && (
                                                        subscriber.deactivated ? (
                                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                                                DELETED
                                                            </span>
                                                        ) : (
                                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                                                                REQUESTED
                                                            </span>
                                                        )
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {this.state.subscribers.length === 0 && (
                                    <div className="text-center py-12 text-gray-500">
                                        No subscribers found
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </AdminLayout>
                <NotificationContainer />
            </>
        )
    }
}

export default withTranslation()(AdminSubscribers)